import { Button, Popover } from '@mantine/core';
import { IconSparkles, IconLoader, IconClick } from '@tabler/icons-react';
import { useState } from 'react';

export function VariableNameSuggestion({
  suggestedVariableName,
  validationReason,
  currentVariableName,
  onApplySuggestion,
  isValidating,
}: {
  suggestedVariableName?: string;
  validationReason?: string;
  currentVariableName: string;
  onApplySuggestion: (name: string) => void;
  isValidating?: boolean;
}) {
  const [opened, setOpened] = useState(false);

  if (!suggestedVariableName || currentVariableName === suggestedVariableName) {
    return isValidating ?
        <Button
          type="button"
          variant="light"
          color="gray"
          size="compact-xs"
          leftSection={
            <IconLoader
              size={12}
              className="animate-spin"
            />
          }
          disabled
          className="h-5 py-0.5 pl-0 pr-2"
        >
          Validating...
        </Button>
      : undefined;
  }

  return (
    <Popover
      width={280}
      position="right"
      withArrow
      shadow="md"
      opened={opened}
      onClose={() => setOpened(false)}
      transitionProps={{ transition: 'fade', duration: 200 }}
    >
      <Popover.Target>
        <Button
          type="button"
          variant="light"
          color="blue"
          size="compact-xs"
          leftSection={
            isValidating ?
              <IconLoader
                size={16}
                className="animate-spin"
              />
            : <IconClick
                size={16}
                className="animate-pulse opacity-100"
              />
          }
          onClick={() => {
            onApplySuggestion(suggestedVariableName);
            setOpened(false);
          }}
          onMouseEnter={() => setOpened(true)}
          onMouseLeave={() => setOpened(false)}
          className="h-5 py-0.5 pl-0 pr-2"
        >
          {suggestedVariableName}
        </Button>
      </Popover.Target>
      <Popover.Dropdown className="dark:bg-neutral-800">
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            {isValidating ?
              <IconLoader
                size={16}
                className="animate-spin text-blue-500"
              />
            : <IconSparkles
                size={16}
                className="text-blue-500"
              />
            }
            <span className="text-sm font-medium">Variable Name Suggestion</span>
          </div>
          {!!validationReason && (
            <div className="flex items-start gap-2">
              <span className="flex-1 text-xs text-gray-600 dark:text-gray-400">
                {validationReason} The AI recommends using &quot;{suggestedVariableName}&quot;.
              </span>
            </div>
          )}
        </div>
      </Popover.Dropdown>
    </Popover>
  );
}
